var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2317 19.668C18.72 20.2233 18.0494 20.501 17.3787 20.501C16.7081 20.501 16.0368 20.2233 15.525 19.668L13.0408 17C13.8631 16.6529 14.7348 16.2206 15.3989 15.5C16.053 14.7901 16.1795 13.8773 16.5 13L19.2324 15.6457C20.2558 16.757 20.2552 18.5574 19.2317 19.668Z",
    fill: "url(#paint0_linear_468_75566)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5844 17.6613C14.4161 17.6613 17.5223 14.5563 17.5223 10.726C17.5223 6.89571 14.4161 3.79065 10.5844 3.79065C6.75265 3.79065 3.64642 6.89571 3.64642 10.726C3.64642 14.5563 6.75265 17.6613 10.5844 17.6613Z",
    fill: "url(#paint1_linear_468_75566)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5843 17.6788C8.80265 17.6788 7.02026 17.001 5.6636 15.6449C4.30695 14.2888 3.62549 12.5844 3.62549 10.726C3.62549 8.86767 4.34945 7.12078 5.6636 5.80712C6.97775 4.49347 8.72531 3.76978 10.5843 3.76978C12.4434 3.76978 14.1909 4.49347 15.5051 5.80712C16.8192 7.12078 17.5432 8.86767 17.5432 10.726C17.5432 12.5844 16.8192 14.3312 15.5051 15.6449C14.1484 17.001 12.3667 17.6788 10.5843 17.6788ZM10.5843 3.81087C8.73646 3.81087 6.99935 4.53038 5.69287 5.83638C4.38638 7.14237 3.6666 8.87882 3.6666 10.726C3.6666 12.5732 4.38638 14.309 5.69287 15.6157C8.39015 18.3119 12.7778 18.3119 15.4751 15.6157C16.7816 14.3097 17.5014 12.5732 17.5014 10.726C17.5014 8.87882 16.7816 7.14237 15.4751 5.83638C14.1686 4.53038 12.4315 3.81087 10.5837 3.81087H10.5843Z",
    fill: "url(#paint2_linear_468_75566)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6038 13.3156C12.1301 13.3156 13.3674 12.0783 13.3674 10.552C13.3674 9.02575 12.1301 7.78845 10.6038 7.78845C9.07751 7.78845 7.84021 9.02575 7.84021 10.552C7.84021 12.0783 9.07751 13.3156 10.6038 13.3156Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75566",
    x1: 14.0783,
    y1: 13.225,
    x2: 19.4118,
    y2: 18.8556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18B7F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185EF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_75566",
    x1: 3.64642,
    y1: 10.7263,
    x2: 17.5223,
    y2: 10.7263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_468_75566",
    x1: 3.62549,
    y1: 10.7246,
    x2: 17.5432,
    y2: 10.7246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorFind);
export default __webpack_public_path__ + "static/media/color-find.ed14525eb20ce52897d6763c6ffb6a14.svg";
export { ForwardRef as ReactComponent };